<template>
      <div style="background:transparent">
          <sbspSalaryFilter :filterList.sync="filterList">
             <el-form-item label="工资月份：" style="margin-right:40px;">
              <div style="display: flex;">
                  <el-select  v-model="filterList[0].value"   placeholder="请选择" style="width:90px;">
                    <el-option  v-for="item in filterList[0].options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                  </el-select>
                  <el-date-picker v-if="filterList[0].value=='qt'" v-model="filterList[0].value2"  style="width:230px;margin-left:4px;"
                      type="monthrange"
                      range-separator="至"
                      start-placeholder="开始月份"
                      end-placeholder="结束月份">
                  </el-date-picker>
              </div>
             </el-form-item>
          </sbspSalaryFilter>
          <div class="boxCon">
              <div class="boxTop">
                  <div>
                    <span>批次信息</span>
                  </div>
                  <div>
                    <span>工资信息</span>
                  </div>
              </div>
              <list v-for="list in dataLists" :key="list.id"  :list="list">
                 <leftButton v-if="list.editState=='10020002'" title="删除" @click="details()" style="top:6px;right:-38px;"></leftButton>
                 <leftButton title="查看详情" @click="details()" style="top:6px;"></leftButton>
              </list>
              <div style="background:#fff;padding:16px 34px 0 0">
                <div class="block">

                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="msgPage.page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="msgPage.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="msgPage.total">
                  </el-pagination>
                </div>
          </div>
          </div>

      </div>

</template>

<script>
  import sbspSalaryFilter from "@/wage-components/sbs-salary-filter/sbsp-salary-filter.vue"
  import list from "@/wage-components/sbs-salary-card/list.vue"
  import leftButton from "@/wage-components/sbs-salary-card/left-button.vue"
  import {queryListPageQuery} from "@/api/wage/wageHis"
  import { queryPmsPayGroupTree } from "@/api/wage/payGroup";
  export default {
    name: "approval",
    components: {
      sbspSalaryFilter,
      list,
      leftButton
    },
    data() {
      return {
         msgPage: {
              limit: 10,
              page: 1,
              total: 0,
              monthStr:'92480001'
            },
        dataLists:[],
            filterList: [
          { text: "工资月份", type: 'select-timer',value:'0',value2:'',name:'wageMonth',
            options:[{
                value: '0',
                label: '当前月'
              }, {
                value: '1',
                label: '近三个月'
              }, {
                value: '2',
                label: '近一年'
              },{
                value: 'qt',
                label: '其他'
              }
              ]
          },
          { text: "批次名称", type: 'text',value:'',name:'batchName'},
          { text: "薪酬组", type: 'select',value:['0'],multiple:true,name:'groupId',
            options: [{
                value: '0',
                label: '黄金糕'
              }, {
                value: '1',
                label: '双皮奶'
              }, {
                value: '2',
                label: '蚵仔煎'
              }, {
                value: '3',
                label: '龙须面'
              }, {
                value: '4',
                label: '北京烤鸭'
              }]
          },
          { text: "社保月份", type: 'timer',value:'',name:'socMonth' },
           { text: "税金月份", type: 'timer',value:'' ,name:'taxMonth'},
           { text: "计税类型", type: 'select',value:['0'],multiple:true,name:'wageType',
            options: [{
                value: '0',
                label: '黄金糕'
              }, {
                value: '1',
                label: '双皮奶'
              }, {
                value: '2',
                label: '蚵仔煎'
              }, {
                value: '3',
                label: '龙须面'
              }, {
                value: '4',
                label: '北京烤鸭'
              }]
          }
        ]
      };
    },
		watch:{
				filterList:{//深度监听，可监听到对象、数组的变化
						handler(val, oldVal){
								val.map((item)=>{
										if(item.value2){
											this.$set(this.msgPage,item.name,item.value2);
										}else{
											if(item.value2==''&&item.value){
													this.$set(this.msgPage,item.name,item.value.split(','));
											}else{
												this.$set(this.msgPage,item.name,item.value);
											}
										}
								})
								this.$set(this.msgPage,'page',1);
								if(this.msgPage.wageMonth=='qt'){
									return ;
								}
								this._queryListPageQuery();
						},
						deep:true //true 深度监听
				}
		},
    created(){
      this.filterLists = JSON.parse(JSON.stringify(this.filterList))
      this._queryPmsPayGroupTree() //查询薪酬组树
      this._queryListPageQuery();
    },
    methods: {
      details(){
        alert(111)
      },
      _queryListPageQuery(){
        queryListPageQuery(this.msgPage).then(res =>{
          this.dataLists = res.data.records;
          // console.log(res)
        })
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.$set(this.msgPage,'limit',val);
      },
      handleCurrentChange(val) {
        this.$set(this.msgPage,'page',val);
        console.log(`当前页: ${val}`);
      },
      //获取薪酬组数据
      _queryPmsPayGroupTree() {
          queryPmsPayGroupTree().then(res => {
              let rs = res.data
              debugger;
              if (rs.code == 0) {
                  this.filterList[2].value = [rs.data[0].id]
                  rs.data.forEach(item => {
                      this.filterList[2].options.push({
                          value: item.id,
                          label: item.groupName
                      })
                  })
                  this.filterLists = JSON.parse(JSON.stringify(this.filterList));
              }
          })
      },
    }
  };
</script>

<style scoped >
  .boxCon{
    background:#fff;
    padding:30px 20px 40px 10px;
  }

  .boxTop{
    display:flex;
    background:rgba(231,231,231,1);
  }
  .boxTop>div:nth-of-type(2){
    flex-grow:1;
  }
  .boxTop span{
    display:inline-block;
    height:34px;
    line-height:34px;
  font-size:14px;
font-weight:500;
color:rgba(0,0,0,1);
 text-align:center;
  }
  .boxTop>div:nth-of-type(1) span{
    width:301px;
     border-right:2px solid #ddd;
       box-sizing: border-box;
  }
   .boxTop>div:nth-of-type(2) span{
    width:100%;

  }
   .boxCon>div:nth-last-of-type(2){
     border-bottom:2px solid #ddd;
   }
</style>
